"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  label: "DELIVERY SUCCESS",
  value: 99,
  suffix: ".8%"
}, {
  label: "DFW COUNTIES",
  value: 15,
  suffix: "+"
}, {
  label: "SE STATES",
  value: 7,
  suffix: ""
}, {
  label: "DISPATCH",
  value: 24,
  suffix: "/7"
}];
interface StatItemProps {
  label: string;
  value: number;
  suffix: string;
  "data-index": number;
}
function StatItem({
  label,
  value,
  suffix,
  "data-index": dataIndex
}: StatItemProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number;
    let animationFrame: number;
    const duration = 2000;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      const easeOut = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);
      setCount(Math.floor(easeOut * value));
      if (percentage < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isVisible, value]);
  return <div data-section-id="120776" ref={ref} data-index={dataIndex} className="flex flex-col items-center justify-center p-6 text-center">
      <div className="text-5xl md:text-[5vw] font-default font-extrabold tracking-tighter text-primary">
        {count}
        {suffix}
      </div>
      <div className="mt-4 text-[10px] md:text-xs font-mono font-medium uppercase tracking-[0.25em] text-muted-foreground">
        {label}
      </div>
    </div>;
}
export default function TheStrategicEdge() {
  return <section id="the-logistics-advantage" className="dark bg-background text-foreground py-12 border-y border-border/20 bg-[linear-gradient(to_right,hsl(var(--border)/0.1)_1px,transparent_1px),linear-gradient(to_bottom,hsl(var(--border)/0.1)_1px,transparent_1px)] bg-[size:4rem_4rem]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-12">
          {stats.map((stat, i) => <StatItem key={i} data-index={i} label={stat.label} value={stat.value} suffix={stat.suffix} />)}
        </div>
      </div>
    </section>;
}